import React, { useState, useEffect } from "react";
import "./SideButton.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComment } from "@fortawesome/free-regular-svg-icons/faComment";
import { faChartBar } from "@fortawesome/free-regular-svg-icons/faChartBar";
import { faStar as faStarOutline } from "@fortawesome/free-regular-svg-icons/faStar";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons/faTrashCan";
import { faStar as faStarSolid } from "@fortawesome/free-solid-svg-icons/faStar";

const SideButton = (props) => {
  const img_icon = props.img_icon;
  const button_text = props.button_text;
  const button_handler = props.button_handler;
  const report = props.report;
  const isReport = props.isReport;
  const hasActions = props.onToggleStar || props.onDelete;

  function runAction(event, handler) {
    event.preventDefault();
    event.stopPropagation();
    handler(report);
  }

  return (
    <div
      className={
        hasActions ? "sidebar_button conversation_row" : "sidebar_button"
      }
    >
      <button
        type="button"
        onClick={() => button_handler(report)}
        className={
          hasActions ? "button_wrapper conversation_open" : "button_wrapper"
        }
      >
        {img_icon != undefined ? (
          <div>
            <img src={img_icon} height="30" width="30" alt=""></img> {"   "}
            {button_text}
          </div>
        ) : isReport == true ? (
          <div className="conversationItem">
            {"   "}
            <FontAwesomeIcon icon={faChartBar} /> {"   "}
            {button_text}
          </div>
        ) : (
          <div className="conversationItem">
            {"   "}
            <FontAwesomeIcon icon={faComment} /> {"   "}
            {button_text}
          </div>
        )}
        {"   "}
      </button>
      {hasActions ? (
        <div className="conversation_actions">
          {props.onToggleStar ? (
            <button
              type="button"
              className={
                props.starred
                  ? "conversation_action conversation_action_star is_starred"
                  : "conversation_action conversation_action_star"
              }
              aria-label={
                props.starred ? "Unstar conversation" : "Star conversation"
              }
              title={props.starred ? "Unstar" : "Star"}
              onClick={(event) => runAction(event, props.onToggleStar)}
            >
              <FontAwesomeIcon icon={props.starred ? faStarSolid : faStarOutline} />
            </button>
          ) : null}
          {props.onDelete ? (
            <button
              type="button"
              className="conversation_action conversation_action_delete"
              aria-label="Delete conversation"
              title="Delete"
              onClick={(event) => runAction(event, props.onDelete)}
            >
              <FontAwesomeIcon icon={faTrashCan} />
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default SideButton;
